// Shared constants across all service categories

// Square footage options in 500 sqft increments
export const SQFT_OPTIONS = [
  { value: "under_1000", label: "Under 1,000 sq ft", sqft: 750 },
  { value: "1000_1500", label: "1,000 - 1,500 sq ft", sqft: 1250 },
  { value: "1500_2000", label: "1,500 - 2,000 sq ft", sqft: 1750 },
  { value: "2000_2500", label: "2,000 - 2,500 sq ft", sqft: 2250 },
  { value: "2500_3000", label: "2,500 - 3,000 sq ft", sqft: 2750 },
  { value: "3000_3500", label: "3,000 - 3,500 sq ft", sqft: 3250 },
  { value: "3500_4000", label: "3,500 - 4,000 sq ft", sqft: 3750 },
  { value: "4000_4500", label: "4,000 - 4,500 sq ft", sqft: 4250 },
  { value: "4500_5000", label: "4,500 - 5,000 sq ft", sqft: 4750 },
  { value: "5000_plus", label: "5,000+ sq ft", sqft: 5500 }
];

// Timeline options used across categories
export const TIMELINE_OPTIONS = [
  { value: "asap", label: "As soon as possible" },
  { value: "1-2_weeks", label: "Within 1-2 weeks" },
  { value: "1_month", label: "Within a month" },
  { value: "quote_only", label: "Just Getting a Quote" }
];

export const EMERGENCY_TIMELINE_OPTIONS = [
  { value: "emergency", label: "Emergency - ASAP" },
  { value: "1-2_weeks", label: "Within 1-2 weeks" },
  { value: "1_month", label: "Within a month" },
  { value: "quote_only", label: "Just Getting a Quote" }
];

// Max characters for additional details
export const MAX_ADDITIONAL_DETAILS = 1000;

// Question types
export const QUESTION_TYPES = {
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
  TEXT: 'text',
  SELECT: 'select',
  COLLAPSIBLE_CATEGORIES: 'collapsible_categories',
  COLLAPSIBLE_ROOM_DETAILS: 'collapsible_room_details'
};
